import TariffQuoteV2 from "../../models/TariffQuoteV2.js"
import { Fuel, UsageType, UsagePeriod } from "./QuoteFormConstants.js"
import GatewayPortalV2 from "../api/GatewayPortalV2.js"

const getFuelTypeRaw = fuelType => {
  if (fuelType === Fuel.ElecAndGas) return "DUAL_FUEL"
  if (fuelType === Fuel.Electricity) return "ELECTRICITY_ONLY"
  if (fuelType === Fuel.Gas) return "GAS_ONLY"

  throw new Error("Invalid fuel type")
}

const getUsageType = usageType => {
  if (usageType === UsageType.low) return "LOW"
  if (usageType === UsageType.medium) return "MEDIUM"
  if (usageType === UsageType.high) return "HIGH"

  return "EXACT_AMOUNT"
}

const calcGasExactUsage = ({ fuel, exactAmountGas, estimatedUsage }) => {
  if (fuel === Fuel.Electricity || estimatedUsage || !exactAmountGas?.usage) {
    return ""
  }

  const usage = Math.round(Number(exactAmountGas.usage))

  if (exactAmountGas.period === UsagePeriod.Month) {
    return Math.round(usage * 12).toString()
  }

  return usage.toString()
}

const calcElecExactUsage = ({ fuel, exactAmountElec, estimatedUsage }) => {
  if (fuel === Fuel.Gas || estimatedUsage || !exactAmountElec?.usage) {
    return ""
  }

  const usage = Math.round(Number(exactAmountElec.usage))

  if (exactAmountElec.period === UsagePeriod.Month) {
    return Math.round(usage * 12).toString()
  }

  return usage.toString()
}

const isEligibleForEvTariff = quoteForm =>
  !!(
    quoteForm.hasSelectedEv &&
    quoteForm.hasValidEv &&
    quoteForm.hasMeterEligibleForEvTariff
  )

const parseQuoteInputData = quoteForm => ({
  postcode: quoteForm.postcode,
  hasEconomySevenMeter: !!quoteForm.isMeterMultirate,
  estimatedUsageType: getUsageType(quoteForm.estimatedUsage),
  fuelType: getFuelTypeRaw(quoteForm.fuel),
  electricityUsagePerYearInKwh: calcElecExactUsage(quoteForm),
  gasUsagePerYearInKwh: calcGasExactUsage(quoteForm),
  generateQuotesForEvTariffs: isEligibleForEvTariff(quoteForm)
})

const sortByCostPerYearInPounds = (a, b) =>
  a.costPerYearInPounds - b.costPerYearInPounds

export default {
  async getQuotes(quoteInputData) {
    const parsedInputData = parseQuoteInputData(quoteInputData)
    const response = await GatewayPortalV2.getQuote(parsedInputData)
    const rawQuotes = response.data ?? []

    if (rawQuotes.length) {
      rawQuotes.sort(sortByCostPerYearInPounds)
      rawQuotes[0].isRecommended = true
    }

    return {
      quotes: rawQuotes.map(rawQuote => new TariffQuoteV2(rawQuote))
    }
  }
}
